import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseUnits } from "viem";
import ABITOMI from "../../utils/tomiAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const useApproveTomi = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const approveTomi = useCallback(
    async (amount) => {
      if (!isConnected || !account) {
        throw new Error("WALLET_NOT_CONNECTED");
      }

      try {
        const approveAmount = parseUnits(amount.toString(), 18);

        const hash = await writeContractAsync({
          address: Environment.tomi,
          abi: ABITOMI,
          functionName: "approve",
          args: [Environment.presaleContract, approveAmount],
        });

        console.log("Approval tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("Approval confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("Approval failed:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { approveTomi };
};

export default useApproveTomi;
